export class Industry {
    _id: string;
    name: string;
    code: Number;
    sapCode: string;
    active: boolean;
    value:number;
    percentage: number;

    loadIndustry(r: any) {
        if (r._id)
            this._id = r._id;
        if (r.name)
            this.name = r.name;
        if (r.code)
            this.code = r.code;
        if (r.sapCode)
            this.sapCode = r.sapCode;
        if (r.active !== undefined)
            this.active = r.active;

        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Industry.model.ts